<section>
  <div class="container">
    <h2 class="title">{{ 'measure-steps-title-web' | translate }}</h2>

    <div>
      <div class="measureSteps">
        <ng-container
          [ngTemplateOutlet]="measureStep"
          [ngTemplateOutletContext]="{
            number: 1,
            headline: 'measure-step-1-title-web' | translate,
            imgSrc: 'https://www.datocms-assets.com/21281/1708687611-image-1.jpg',
            text: 'measure-step-1-text-web' | translate,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="measureStep"
          [ngTemplateOutletContext]="{
            number: 2,
            headline: 'measure-step-2-title-web' | translate,
            imgSrc: 'https://www.datocms-assets.com/21281/1708687631-image2.jpg',
            text: 'measure-step-2-text-web' | translate,
          }"
        />

        <ng-container
          [ngTemplateOutlet]="measureStep"
          [ngTemplateOutletContext]="{
            number: 3,
            headline: 'measure-step-3-title-web' | translate,
            imgSrc: 'https://www.datocms-assets.com/21281/1708687655-image3-1.jpg',
            text: 'measure-step-3-text-web' | translate,
          }"
        />
      </div>

      <ng-template
        #measureStep
        let-number="number"
        let-headline="headline"
        let-imgSrc="imgSrc"
        let-text="text"
      >
        <div class="measureStep">
          <div class="headline">
            <div class="headlineNumber">{{ number }}</div>
            <div class="headlineText">{{ headline }}</div>
          </div>

          <img datoImage [imgixWidth]="750" class="image" [src]="imgSrc" alt="" />

          <div class="text">
            {{ text }}
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</section>
